<div class="biloba-gtm-warning">
    <div class="biloba-gtm-warning__body">
        <div class="biloba-gtm-warning__icon">!</div>
        <div class="biloba-gtm-warning__content">
            <p v-if="isGerman">
                <strong>Wichtig bei Verwendung des Google Tag Managers:</strong><br/>
                Bitte vergiss nicht, unser GTM-Container-Template zu importieren.
                Das spart dir die manuelle Einrichtung und garantiert eine korrekte Datenerfassung.
                Die Anleitung sowie das passende Template findest du hier.
            </p>
            <p v-else>
                <strong>Important when using Google Tag Manager:</strong><br/>
                Don't forget to import our GTM container template.
                It saves you the manual setup and ensures correct data collection.
                You can find the instructions and matching template here.
            </p>
            <div class="biloba-gtm-warning__buttons">
                <sw-button variant="primary" link="https://www.biloba-it.de/doku/google-tag-manager/?etcc_cmp=Plugins&etcc_med=Plugin-Link#gtm-template-generator">
                    {{ isGerman ? '→ Zur Dokumentation' : '→ Documentation' }}
                </sw-button>
            </div>
        </div>
    </div>
</div>
